import React from 'react';
import { Toast } from 'antd-mobile';
import { registerMicroApps, start, loadMicroApp } from 'qiankun';
import actions from '../../actions';
import config from './config.json';
import configScale from './configScale.json';
import configDevScale from './configDevScale.json';
import utils from '../../utils/utils';
// import { basename } from '../common/common';

let env = process.env.REACT_APP_ENV;

let microApp: any = null;

declare const wx: any;

class CRFComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            params: {},
            saveData: null, // 保存数据
        };

    }

    componentWillMount = () => {

        // 注册一个观察者函数
        actions.onGlobalStateChange((state, prev) => {
            // 接收子应用保存状态信息
            if (state.data.callback == 'submitSuccess') {
                if (this.props.formItemSave) {
                    // 清除记录的表单数据
                    if (localStorage.getItem('scaleCode_' + this.props.params.crfCode)) {
                        localStorage.removeItem('scaleCode_' + this.props.params.crfCode);
                    }
                }
                this.props.onSaveSuccess(state.data.params)
            } else if (state.data.callback == 'transmitSuccess') {
                this.props.onTransmitSuccess(state.data.params)
            }
        });

    }

    init = (readonly = false) => {
        let { params } = this.props;
        if (params) {
            let data = {
                data: { // 数据初始化
                    plugnType: "crf",
                    event: 'onInit',
                    params: {
                        channel: params.channel,
                        crfCode: params.crfCode,
                        crfVersion: params.crfVersion,
                        recordCode: params.recordCode,
                        tenantCode: params.tenantCode
                    },
                    readonly: readonly,
                    formItemSave: !!this.props.formItemSave // 记录表单元素历史数据然后反显
                }
            }
            actions.setGlobalState(data);
        }
    }

    // 数据保存
    handleSubmit = () => {
        this.handleSaveAndSubmit('onSubmit')
    }

    // 数据暂存
    handleSave = () => {
        this.handleSaveAndSubmit('onSave')
    }

    // 数据保存 或 暂存 时传递参数
    handleSaveAndSubmit = (event: any) => {
        let { params } = this.props;
        let data = {
            data: {
                plugnType: "crf",
                event: event,
                params: {
                    caseCode: params.caseCode,
                    channel: params.channel,
                    crfCode: params.crfCode,
                    crfVersion: params.crfVersion,
                    eventCode: params.eventCode,
                    headers: params.headers,
                    projectCode: params.projectCode,
                    recordCode: params.recordCode,
                    tenantCode: params.tenantCode,
                    userCode: params.userCode
                }
            },
        }
        actions.setGlobalState(data);
    }



    componentDidMount = () => {
        // sessionStorage.setItem('QianKunUrlPrefix', basename);
        sessionStorage.setItem('QianKunUrlPrefix', '/wechat');
        sessionStorage.setItem('channel', 'EDC');
        // 注册子应用
        // registerMicroApps(
        //     [
        //         {
        //             name: 'crf-plugn', //微应用的名称，微应用之间必须确保唯一(微应用中package.json中的name)
        //             entry: config.entry[`${env}`], //微应用的entry地址
        //             container: '#crf',//微应用的容器节点的选择器
        //             activeRule: `${basename}/crf`,//微应用的激活规则
        //         }
        //     ]
        // );
        // start();
        this.loadApp();
        const urlParams = utils.getUrlParams();
        let _readonly = false
        if (urlParams && urlParams.readonly === 'true') {
            _readonly = true;
        }
        this.init(_readonly || this.props.readonly);
    }

    /**
    * 手动加载微应用
    */
    loadApp = () => {
        let mConfig = config;
        if (this.props.type === 'scale') {
            const formalConfig = true; // 正式环境config
            mConfig = formalConfig ? configScale : configDevScale;
        }
        microApp = loadMicroApp({
            name: 'crf-plugn', //微应用的名称，微应用之间必须确保唯一(微应用中package.json中的name)
            entry: mConfig.entry[`${env}`], //微应用的entry地址
            container: '#crf',//微应用的容器节点的选择器
        });
    };

    /**
     * 卸载微应用
     */
    unloadApp = () => {
        if (microApp) {
            microApp.unmount();
        }
    };

    componentWillUnmount() {
        this.unloadApp()
    }

    render() {

        return (
            <div id='crf'></div>
        );
    }
}
export default CRFComponent;
